import { DataStore, initSchema } from './datastore/datastore';
import { Predicates } from './predicates';
export * from './types';
export { DataStore, initSchema, Predicates };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/datastore/lib-esm/index.js
// module id = null
// module chunks = 